import { Injectable, forwardRef, Inject } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LoginService } from 'src/app/Services/Login/login.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    constructor(@Inject(forwardRef(() => LoginService)) private authenticationService: LoginService) { }
    
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
      //  const currentUser = this.authenticationService._getpToken();
        const isLoggedIn = sessionStorage.getItem('pToken');

        if (isLoggedIn !== "" && isLoggedIn !== null) {

            request = request.clone({
                setHeaders: {
                    Authorization: `Bearer ${sessionStorage.getItem('pToken')}`
                }
            });
        }

        return next.handle(request);
    }
}
